import { activeCouncilNames } from '../../config/registry';

export const ALL_COUNCILS = activeCouncilNames();
export const ALL_STATUS_KEYS = ['Lodged', 'Under Assessment', 'On Exhibition', 'Approved', 'Rejected'];
